/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { address } from '../../common/address';
import { entity } from '../../common/entity';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from '../../icetypes';

export class claimambulance extends IceEntity {
  claim_ambulance_key: string = "";
  weight_unit_code: string = "";
  weight: number = 0.0;
  ambulance_transport_code: string = "";
  ambulance_transport_reason_code: string = "";
  transport_distance: number = 0.0;
  transport_distance_unit_code: string = "";
  pickup_entity_key: string = "";
  pickup_address_key: string = "";
  pickup_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  pickup_trans_account: string = "";
  dropoff_entity_key: string = "";
  dropoff_address_key: string = "";
  dropoff_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  dropoff_trans_account: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  ENTS: entity[] = [];
  ADS: address[] = [];

  constructor() {
    super();
  }

  gettablename(): string {
    return "CLAIM_AMBULANCE";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "ADS") return true;
    else if (ColumnName == "ENTS") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "ADS") return "ADDRESS";
    else if (ColumnName == "ENTS") return "ENTITY";

    return null;
  }

  getdisplayname(ent_key: string): string {
    var ent = this.getsubtreedata("ENTS", "entity_key", ent_key);
    if (ent == null) return "";

    return ent.organization_name;
  }
}
